<div id="activities" *ngIf="activities">
  <ng-container *ngFor="let activity of activities">
    <h5>
      {{ activity.model.screenName }}&nbsp;
      <span
        style="font-size: .9rem;"
        *ngIf="activity && activity.status === ActivityStatus.Completed"
        >Completed On {{ activity.completedOnString }} by
        {{ activity.completedBy }}</span
      >
    </h5>
    <wm-activity-view
      [activity]="activity"
      [isReadOnly]="true"
      [form]="form"
      [isPreview]="false"
    ></wm-activity-view>
  </ng-container>

  <!-- JANUS SIDE: Show the simplified external notes only safely without async flash -->
  <div *ngIf="showJanusNotesCard" style="margin-top: 16px;">
    <h5>Notes</h5>
    
    <ng-container *ngIf="!isLoadingJanusNotes">
      <wm-application-external-note-editor
        *ngIf="hasExternalNotes && !hasNewExternalNotes"
        [application]="application"
        [readOnly]="true"
        [notesOnly]="true"
      ></wm-application-external-note-editor>

      <div class="janus-readonly-notes-list" *ngIf="hasNewExternalNotes">
         <div *ngFor="let note of janusExternalNotesList" class="janus-readonly-note-item">
            {{ note.note || note.notes || note.externalNotes }}
         </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="!templateForPermitForm">
    <h5>External Notes</h5>
    <wm-application-external-note-editor
      [application]="application"
      [readOnly]="true"
    ></wm-application-external-note-editor>
  </div>

  <div *ngIf="!templateForPermitForm && canViewInternalNotes">
    <h5>Internal Notes</h5>
    <wm-application-internal-note-editor
      [application]="application"
      [readOnly]="true"
    ></wm-application-internal-note-editor>
  </div>
</div>
